import { useParams } from 'react-router-dom';
import { useGetFamiliesQuery } from '../app/api-slice';
import { LoadingPage } from './loading-page';
import { ErrorPage } from './error-page';
import { ChooseFamily } from '../view/choose-family/choose-family';
import { useMessages2 } from '../hooks/useLanguage';
import { useImageURLToFamily } from '../hooks/useImageURLtoFamily';
import { useDataRequestLang } from '../app/main-slice';
import { useCategoryName } from '../hooks/navigation-names';
import { PageMetadata } from '../view/page-metadata';

export const ChooseFamilyPage = () => {

    const lang = useDataRequestLang();
    const { categoryId } = useParams();
    const { data: families = [], isLoading, isSuccess, isError, error } = useGetFamiliesQuery({
        lang,
        category: categoryId!
    });
    
    const {isLoading: isLoadingMessage, isSuccess: isSuccessMessage, messages } = useMessages2();
    const familiesWithImages = useImageURLToFamily(families);

    const categoryName = useCategoryName(categoryId!);

    let content;
    if(isLoading || isLoadingMessage) {
        content = <LoadingPage/>;
    } else if(isSuccess && categoryId && isSuccessMessage) {
        content = <ChooseFamily categoryId={categoryId} families={familiesWithImages} />
    } else {
        content = <ErrorPage error={error}/>
    }

    return <>
        <PageMetadata pageTitle={ categoryName } />
        { content }
    </>
}